import { type AppState, Auth0Provider, type User } from '@auth0/auth0-react';
import type { Auth0Config } from '@portals-platform/brand-kit';
import type { ReactNode } from 'react';

interface BrandAuth0ProviderProps {
  config: Auth0Config;
  children: ReactNode;
  onRedirectCallback?: (appState?: AppState, user?: User) => void;
}

/**
 * Wraps @auth0/auth0-react Auth0Provider with brand-specific configuration.
 * Brand apps do not interact with Auth0 directly — they pass their config
 * and this provider handles the rest.
 */
export function BrandAuth0Provider({
  config,
  children,
  onRedirectCallback,
}: BrandAuth0ProviderProps) {
  return (
    <Auth0Provider
      domain={config.domain ?? ''}
      clientId={config.clientId ?? ''}
      authorizationParams={{
        audience: config.audience,
        redirect_uri: config.redirectUri,
      }}
      {...(onRedirectCallback !== undefined ? { onRedirectCallback } : {})}
    >
      {children}
    </Auth0Provider>
  );
}
